export default "__VITE_ASSET__CoJAt8gt__"